/******/ (() => { // webpackBootstrap
/*!******************************!*\
  !*** ./src/js/bundle-app.js ***!
  \******************************/
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var bundleApp = {
  init: function init() {
    var _priceEl$textContent;
    var bundleJson = document.querySelector('#bundleJson');
    if (!bundleJson) return;
    var bundlePayload = JSON.parse(bundleJson.textContent);
    console.log("BUNDLE PAYLAOD", bundlePayload);
    var addCart = document.querySelector('#product-bundle [data-addcart]');
    var addToCarts = document.querySelectorAll('#product-bundle [data-addcart]');
    var quantityInput = document.querySelector('[data-quantity-input][name="quantity"]');
    var priceEl = addCart === null || addCart === void 0 ? void 0 : addCart.querySelector('.bundle-total-price-js');
    document.querySelector(".quick-add-mob-product-price").innerHTML = document.querySelector(".bundleprice").innerHTML;
    var parsedPrice = parseFloat((_priceEl$textContent = priceEl === null || priceEl === void 0 ? void 0 : priceEl.textContent) !== null && _priceEl$textContent !== void 0 ? _priceEl$textContent : 0);
    document.querySelectorAll('[data-quantity-input][name="quantity"]').forEach(function (el) {
      el.addEventListener('input', function (e) {
        var _document$getElementB;
        var newParsedComparePrice = parseFloat(document.getElementById("bundleCompareTotalPrice").value);
        //const parsedPrice = parseFloat(priceEl?.textContent ?? 0);
        var newParsedPrice = parseFloat((_document$getElementB = document.getElementById("bundleTotalPrice").value) !== null && _document$getElementB !== void 0 ? _document$getElementB : 0);
        if (parsedPrice === 0 || !priceEl) return;
        document.querySelectorAll('.bundle-total-price-js').forEach(function (el) {
          el.textContent = (newParsedPrice / 100.00 * e.target.value).toFixed(2);
        });
        document.querySelectorAll('.bundle-compare-price-js').forEach(function (el) {
          el.textContent = (newParsedComparePrice / 100.00 * e.target.value).toFixed(2);
        });
        document.querySelector(".quick-add-mob-product-price").innerHTML = document.querySelector(".bundleprice").innerHTML;
      });
    });
    function getVariantPricing(variantId, bundlePayload) {
      var cleanVariantId = String(variantId).replace("gid://shopify/ProductVariant/", "");
      var matchedVariant = bundlePayload.variants.find(function (variant) {
        return String(variant.id) === cleanVariantId;
      });
      if (!matchedVariant) {
        return {
          price: 0,
          compare_at_price: 0
        };
      }
      return {
        price: Number(matchedVariant.price || 0),
        compare_at_price: Number(matchedVariant.compare_at_price || matchedVariant.price || 0)
      };
    }
    function addBundleCart() {
      return _addBundleCart.apply(this, arguments);
    }
    function _addBundleCart() {
      _addBundleCart = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _bundlePayload$bundle, _bundlePayload$steps;
        var quickAddModal, isQuickAdd, formData, quantityInputValue, bundleCards, bundleSelections, bundleUUID, giftInput, giftForm, cart, config, response, responseJson, add, cartDrawer, cartBubble, cartcontent, _t, _t2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              quickAddModal = bundleJson.closest('quick-add-modal');
              isQuickAdd = quickAddModal !== null;
              formData = {
                items: []
              };
              addToCarts.forEach(function (el) {
                var _el$querySelector;
                (_el$querySelector = el.querySelector('.loading-overlay__spinner')) === null || _el$querySelector === void 0 || _el$querySelector.classList.remove('hidden');
                el.disabled = true;
              });
              quantityInputValue = (quantityInput === null || quantityInput === void 0 ? void 0 : quantityInput.value) || 1;
              bundleCards = Array.from(document.querySelectorAll('bundle-item-card')); // const bundleSelections = bundleCards.map((card) => ({
              //     productId: card.dataset.productId,
              //     variantId: card.dataset.variantGid,
              //     quantity: Number(card.dataset.itemQuantity || 1),
              //     stepTitle: card.dataset.stepTitle || '',
              // }));
              bundleSelections = bundleCards.map(function (card) {
                var pricing = getVariantPricing(card.dataset.variantGid, bundlePayload);
                return {
                  productId: card.dataset.productId,
                  variantId: card.dataset.variantGid,
                  quantity: Number(card.dataset.itemQuantity || 1),
                  stepTitle: card.dataset.stepTitle || '',
                  price: pricing.price,
                  compare_at_price: pricing.compare_at_price
                };
              }); // console.log("BUNDLE SELECTUON" , bundleSelections)
              bundleUUID = [(_bundlePayload$bundle = bundlePayload.bundleData) === null || _bundlePayload$bundle === void 0 ? void 0 : _bundlePayload$bundle.mainId, bundleSelections.map(function (item) {
                return "".concat(item.variantId, ":").concat(item.quantity);
              }).join('|')].join('::');
              formData.items.push({
                id: Number((_bundlePayload$steps = bundlePayload.steps) === null || _bundlePayload$steps === void 0 || (_bundlePayload$steps = _bundlePayload$steps[0]) === null || _bundlePayload$steps === void 0 ? void 0 : _bundlePayload$steps.variantId),
                quantity: Number(quantityInputValue),
                properties: {
                  _bundle: bundleUUID,
                  _bundle_selections: JSON.stringify(bundleSelections)
                }
              });

              // gift product logic
              giftInput = document.querySelector('[data-gift-product-input]');
              giftForm = document.querySelector('[data-gift-box-form]');
              if (giftInput && giftForm && giftInput.checked) {
                formData.items.push({
                  id: Number(giftInput.dataset.giftVariant),
                  quantity: 1,
                  properties: {
                    _gift_box_for_product: giftInput.dataset.giftForProduct,
                    _gift_box_message: giftForm.querySelector('[name=message]').value,
                    _gift_box_recipient: giftForm.querySelector('[name=recipient]').value,
                    _gift_box_sender: giftForm.querySelector('[name=sender]').value
                  }
                });
              }

              // gift product logic end here
              if (!isQuickAdd) {
                _context.n = 5;
                break;
              }
              cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
              config = fetchConfig('javascript');
              if (cart) {
                formData.sections = cart.getSectionsToRender().map(function (section) {
                  return section.id;
                });
                formData.sections_url = window.location.pathname;
                cart.setActiveElement(document.activeElement);
              }
              config.body = JSON.stringify(formData);
              _context.n = 1;
              return fetch(window.Shopify.routes.root + 'cart/add.js', config);
            case 1:
              response = _context.v;
              if (response.ok) {
                _context.n = 3;
                break;
              }
              _t = console;
              _context.n = 2;
              return response.text();
            case 2:
              _t2 = _context.v;
              _t.error.call(_t, 'Error:', _t2);
              console.error('Config:', config);
              addToCarts.forEach(function (el) {
                var _el$querySelector2;
                (_el$querySelector2 = el.querySelector('.loading-overlay__spinner')) === null || _el$querySelector2 === void 0 || _el$querySelector2.classList.add('hidden');
                el.disabled = false;
              });
              return _context.a(2);
            case 3:
              _context.n = 4;
              return response.json();
            case 4:
              responseJson = _context.v;
              cart === null || cart === void 0 || cart.renderContents(responseJson, true);
              quickAddModal.handleQuickAddThankYouModal(responseJson);
              return _context.a(2);
            case 5:
              _context.n = 6;
              return fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
              }).then(function (response) {
                return response.json();
              })["catch"](function (error) {
                console.error('Error:', error);
              });
            case 6:
              add = _context.v;
              // update cart-drawer. fetch, then parse html
              cartDrawer = document.querySelector('cart-drawer');
              cartBubble = document.querySelector('#cart-icon-bubble');
              _context.n = 7;
              return fetch(window.location, {}).then(function (response) {
                return response.text();
              }).then(function (responseText) {
                var html = new DOMParser().parseFromString(responseText, 'text/html');
                if (cartBubble) cartBubble.innerHTML = html.querySelector('#cart-icon-bubble').innerHTML;
                cartDrawer.innerHTML = html.querySelector('cart-drawer').innerHTML;
                document.querySelector('cart-drawer').open();
                App.overflowFloatedStyle();
                if (document.querySelector('.cart__contents .splide:not(.splide-custom):not(.is-initialized)')) {
                  SplideConfig.initSplides('.cart__contents .splide:not(.splide-custom):not(.is-initialized)');
                }
                addToCarts.forEach(function (el) {
                  var _el$querySelector3;
                  (_el$querySelector3 = el.querySelector('.loading-overlay__spinner')) === null || _el$querySelector3 === void 0 || _el$querySelector3.classList.add('hidden');
                  el.disabled = false;
                });
              });
            case 7:
              cartcontent = _context.v;
            case 8:
              return _context.a(2);
          }
        }, _callee);
      }));
      return _addBundleCart.apply(this, arguments);
    }
    document.querySelectorAll('bundle-item-card').forEach(function (el) {
      el.addEventListener('change', function () {
        addToCarts.forEach(function (el) {
          el.disabled = document.querySelectorAll('bundle-item-card[data-has-selection=false]').length;
        });
      });
    });
    addToCarts.forEach(function (el) {
      el.disabled = document.querySelectorAll('bundle-item-card[data-has-selection=false]').length;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        void addBundleCart();
      });
    });
  }
};
if (document.querySelector('#product-bundle').closest('.quick-add-modal__content-info')) {
  bundleApp.init();
}
document.addEventListener('DOMContentLoaded', function () {
  bundleApp.init();
});
/******/ })()
;